export const translations = {
    ru: {
        nav: {
            favorite: 'Избранное',
            search: 'Поиск',
            allergens: 'Аллергены',
        },
        buttons: {
            addToCart: 'Добавить в корзину'
        },
        search: {
            placeholder: "Поиск...",
            nothingFound: "Ничего не найдено"
        },
        order: {
            title: "Оформление заказа",
            success: {
                title: "Готово",
                message: "Заказ успешно оформлен. Мы перезвоним вам в ближайшее время",
                orderNumber: "Номер вашего заказа"
            },
            error: {
                title: "Ошибка",
                placement: "Ошибка размещения заказа"
            }
        },
        cart: {
            all: "Все",
            title: "Моя корзина",
            empty: "В заказе нет позиций",
            widget: "В корзине",
            openMenu: "Открыть меню",
            unnamed: "Без названия",
            notInCart: "ещё не добавлен в корзину",
            buttons: {
                retry: "Повторить попытку",
                returnToMenu: "Вернуться в меню",
                saveMenu: "Сохранить меню на телефон"
            }
        },
        filters: {
            allergens: 'Аллергены'
        },
        blocks: {
            recommendations: {
                title: "Рекомендуем",
                empty: "Нет рекомендаций"
            },
            favorites: {
                title: "Ваши любимые блюда",
                empty: "Нет избранных блюд"
            },
            total: {
                sum: "Сумма",
                delivery: "Доставка",
                total: "Итого"
            }
        },
        footer: {
            address: "Адрес",
            contacts: "Контакты",
            privacyPolicy: "Политика конфиденциальности",
            termsOfUse: "Пользовательское соглашение"
        },
        cartOrder: {
            placeOrder: "Оформить заказ",
            closed: "Ресторан закрыт",
            minOrder: "Минимальный заказ",
            minOrderMessage: "Сумма вашего заказа ниже минимальной. Для оформления заказа вам необходимо добавить в корзину товары на сумму не менее",
            deliveryClosedMessage: "К сожалению сейчас служба доставки не работает, мы примем ваш заказ и обработаем его сразу же как только она откроется.",
            openInMinutes: "Доставка откроется через",
            minutes: "мин.",
            openAt: "Доставка работает с"
        },
        dmLabel: {
            text: "Это меню сделано на платформе",
        },
        nutrition: {
            title: "Пищевая ценность",
            weight: "Вес порции",
            perServing: "на порцию",
            addToFavorites: "В избранное",
            inFavorites: "В избранном",
            calories: 'ккал',
            proteins: 'белки',
            fats: 'жиры',
            carbs: 'углеводы',
            gram: 'г'
        },
        allergens: {
            contains: 'Содержит',
            cereals: 'Злаки',
            avocado: 'Авокадо',
            peanuts: 'Арахис',
            gluten: 'Глютен',
            mustard: 'Горчица',
            sulphurdioxide: 'Диоксид серы',
            sesame: 'Кунжут',
            lupin: 'Люпин',
            molluscs: 'Моллюски',
            milk: 'Молоко',
            nuts: 'Орехи',
            crustaceans: 'Ракообразные',
            fish: 'Рыба',
            celery: 'Сельдерей',
            soya: 'Соя',
            eggs: 'Яйца'
        },
        addToCart: {
            add: "Добавить",
            added: "Добавлено"
        },
        details: {
            description: "Описание",
            ingredients: "Состав",
            weight: "Вес",
            close: "Закрыть"
        },
        price: {
            from: "от"
        },
        orderScreen: {
            title: "Оформление заказа",
            deliveryType: {
                label: "Как вы хотите получить заказ?",
                onsite: "В заведении",
                delivery: "Доставить по адресу",
                pickup: "Самовывоз"
            },
            fields: {
                deliveryRegion: "Район доставки",
                pickupPoint: "Пункт самовывоза",
                name: "Имя",
                phone: "Телефон",
                address: "Адрес доставки",
                comment: "Комментарий к заказу"
            },
            placeholders: {
                deliveryRegion: "В какой район доставить?",
                name: "Как к вам обращаться?",
                phone: "+7 000 000 00 00",
                address: "Куда доставить?",
                comment: "Комментарий к заказу"
            },
            errors: {
                deliveryRegion: "* Пожалуйста, выберите район",
                name: "* Пожалуйста, укажите имя",
                phone: {
                    empty: "* Укажите телефон для связи",
                    invalid: "* Кажется телефон указан не верно. Должно быть не менее 5ти цифр"
                },
                address: "* Пожалуйста, укажите адрес",
                comment: "* Добавьте комментарий к заказу",
                pickupPoint: "* Укажите где бы вы хотели забрать заказ"
            },
            deliveryInfo: {
                cost: "Стоимость доставки в этот район составит"
            },
            agreement: {
                text: "Продолжая, вы даёте согласие на обработку персональных данных и соглашаетесь с",
                userAgreement: "Пользовательским соглашением",
                and: "и",
                privacyPolicy: "Политикой конфиденциальности"
            }
        },
        modSelector: {
            outOfStock: "нет в наличии"
        },
        variantSelector: {
            chooseOption: 'Выберите вариант'
        },
        notifications: {
            productStopped: 'Временно недоступно',
            maxQuantityExceeded: 'Для этой позиции действует ограничение - не более {max} в заказе'
        }
    },
    en: {
        nav: {
            favorite: 'Favorite',
            search: 'Search',
            allergens: 'Allergens',
        },
        buttons: {
            addToCart: 'Add to Cart'
        },
        search: {
            placeholder: "Search...",
            nothingFound: "Nothing found"
        },
        order: {
            title: "Place Order",
            success: {
                title: "Done",
                message: "Order successfully placed. We will call you back shortly",
                orderNumber: "Your order number"
            },
            error: {
                title: "Error",
                placement: "Error placing order"
            }
        },
        cart: {
            all: "All",
            title: "My Cart",
            empty: "Cart is empty",
            widget: "In Cart",
            openMenu: "Open Menu",
            unnamed: "Unnamed",
            buttons: {
                retry: "Retry",
                returnToMenu: "Return to Menu",
                saveMenu: "Save Menu to Phone"
            }
        },
        filters: {
            allergens: 'Allergens'
        },
        blocks: {
            recommendations: {
                title: "Recommended",
                empty: "No recommendations"
            },
            favorites: {
                title: "Your Favorites",
                empty: "No favorite dishes"
            },
            total: {
                sum: "Sum",
                delivery: "Delivery",
                total: "Total"
            }
        },
        footer: {
            address: "Address",
            contacts: "Contacts",
            privacyPolicy: "Privacy Policy",
            termsOfUse: "Terms of Use"
        },
        cartOrder: {
            placeOrder: "Place Order",
            closed: "Restaurant is closed",
            minOrder: "Minimum order",
            minOrderMessage: "Your order amount is below the minimum. To place an order, you need to add items worth at least",
            deliveryClosedMessage: "Unfortunately, the delivery service is currently closed. We will accept your order and process it as soon as it opens.",
            openInMinutes: "Delivery opens in",
            minutes: "min.",
            openAt: "Delivery works from"
        },
        dmLabel: {
            text: "Made with",
        },
        nutrition: {
            title: "Nutrition Facts",
            weight: "Serving size",
            perServing: "per serving",
            addToFavorites: "Add to favorites",
            inFavorites: "In favorites",
            calories: 'cal',
            proteins: 'protein',
            fats: 'fat',
            carbs: 'carbs',
            gram: 'g'
        },
        allergens: {
            contains: 'Contains',
            avocado: 'Avocado',
            peanuts: 'Peanuts',
            gluten: 'Gluten',
            mustard: 'Mustard',
            sulphurdioxide: 'Sulphur dioxide',
            sesame: 'Sesame',
            lupin: 'Lupin',
            molluscs: 'Molluscs',
            milk: 'Milk',
            nuts: 'Nuts',
            crustaceans: 'Crustaceans',
            fish: 'Fish',
            celery: 'Celery',
            soya: 'Soya',
            eggs: 'Eggs'
        },
        addToCart: {
            add: "Add",
            added: "Added"
        },
        details: {
            description: "Description",
            ingredients: "Ingredients",
            weight: "Weight",
            close: "Close"
        },
        price: {
            from: "from"
        },
        orderScreen: {
            title: "Place Order",
            deliveryType: {
                label: "How would you like to receive your order?",
                onsite: "At restaurant",
                delivery: "Delivery to address",
                pickup: "Pickup"
            },
            fields: {
                deliveryRegion: "Delivery area",
                pickupPoint: "Pickup point",
                name: "Name",
                phone: "Phone",
                address: "Delivery address",
                comment: "Order comment"
            },
            placeholders: {
                deliveryRegion: "Which area to deliver to?",
                name: "What should we call you?",
                phone: "+1 000 000 0000",
                address: "Where to deliver?",
                comment: "Order comment"
            },
            errors: {
                deliveryRegion: "* Please select a delivery area",
                name: "* Please enter your name",
                phone: {
                    empty: "* Please provide a contact phone",
                    invalid: "* The phone number seems incorrect. It should have at least 5 digits"
                },
                address: "* Please provide the delivery address",
                comment: "* Please add a comment to your order",
                pickupPoint: "* Please specify where you would like to pick up your order"
            },
            deliveryInfo: {
                cost: "Delivery cost to this area will be"
            },
            agreement: {
                text: "By continuing, you consent to the processing of personal data and agree to the",
                userAgreement: "User Agreement",
                and: "and",
                privacyPolicy: "Privacy Policy"
            }
        },
        modSelector: {
            outOfStock: "out of stock"
        },
        variantSelector: {
            chooseOption: 'Choose option'
        },
        notifications: {
            productStopped: 'Temporarily unavailable',
            maxQuantityExceeded: 'There is a limit of {max} items per order for this product'
        }
    },
    es: {
        nav: {
            favorite: 'Favoritos',
            search: 'Búsqueda',
            allergens: 'Alérgenos',
        },
        buttons: {
            addToCart: 'Añadir al Carrito'
        },
        search: {
            placeholder: "Buscar...",
            nothingFound: "No se encontró nada"
        },
        order: {
            title: "Realizar Pedido",
            success: {
                title: "¡Listo!",
                message: "Pedido realizado con éxito. Te llamaremos en breve",
                orderNumber: "Número de tu pedido"
            },
            error: {
                title: "Error",
                placement: "Error al realizar el pedido"
            }
        },
        cart: {
            all: "Todo",
            title: "Mi Carrito",
            empty: "El carrito está vacío",
            widget: "En el Carrito",
            openMenu: "Abrir Carta",
            unnamed: "Sin nombre",
            buttons: {
                retry: "Reintentar",
                returnToMenu: "Volver a la Carta",
                saveMenu: "Guardar Carta en el Teléfono"
            }
        },
        filters: {
            allergens: 'Alérgenos'
        },
        blocks: {
            recommendations: {
                title: "Recomendados",
                empty: "Sin recomendaciones"
            },
            favorites: {
                title: "Tus Favoritos",
                empty: "Sin platos favoritos"
            },
            total: {
                sum: "Suma",
                delivery: "Entrega",
                total: "Total"
            }
        },
        footer: {
            address: "Dirección",
            contacts: "Contactos",
            privacyPolicy: "Política de Privacidad",
            termsOfUse: "Términos de Uso"
        },
        cartOrder: {
            placeOrder: "Realizar Pedido",
            closed: "Restaurante cerrado",
            minOrder: "Pedido mínimo",
            minOrderMessage: "El monto de su pedido está por debajo del mínimo. Para realizar un pedido, debe agregar artículos por un valor de al menos",
            deliveryClosedMessage: "Desafortunadamente, el servicio de entrega está cerrado actualmente. Aceptaremos su pedido y lo procesaremos tan pronto como abra.",
            openInMinutes: "La entrega abre en",
            minutes: "min.",
            openAt: "La entrega funciona desde"
        },
        dmLabel: {
            text: "Hecho con",
        },
        nutrition: {
            title: "Información Nutricional",
            weight: "Tamaño de porción",
            perServing: "por porción",
            addToFavorites: "Añadir a favoritos",
            inFavorites: "En favoritos",
            calories: 'cal',
            proteins: 'proteínas',
            fats: 'grasas',
            carbs: 'carbohidratos',
            gram: 'g'
        },
        allergens: {
            contains: 'Contiene',
            avocado: 'Aguacate',
            peanuts: 'Cacahuetes',
            gluten: 'Gluten',
            mustard: 'Mostaza',
            sulphurdioxide: 'Dióxido de azufre',
            sesame: 'Sésamo',
            lupin: 'Altramuz',
            molluscs: 'Moluscos',
            milk: 'Leche',
            nuts: 'Frutos secos',
            crustaceans: 'Crustáceos',
            fish: 'Pescado',
            celery: 'Apio',
            soya: 'Soja',
            eggs: 'Huevos'
        },
        addToCart: {
            add: "Añadir",
            added: "Añadido"
        },
        details: {
            description: "Descripción",
            ingredients: "Ingredientes",
            weight: "Peso",
            close: "Cerrar"
        },
        price: {
            from: "desde"
        },
        orderScreen: {
            title: "Realizar Pedido",
            deliveryType: {
                label: "¿Cómo desea recibir su pedido?",
                onsite: "En el local",
                delivery: "Entrega a domicilio",
                pickup: "Para llevar"
            },
            fields: {
                deliveryRegion: "Zona de entrega",
                pickupPoint: "Punto de recogida",
                name: "Nombre",
                phone: "Teléfono",
                address: "Dirección de entrega",
                comment: "Comentario del pedido"
            },
            placeholders: {
                deliveryRegion: "¿A qué zona entregar?",
                name: "¿Cómo debemos llamarte?",
                phone: "+34 000 000 000",
                address: "¿Dónde entregar?",
                comment: "Comentario del pedido"
            },
            errors: {
                deliveryRegion: "* Por favor, seleccione una zona de entrega",
                name: "* Por favor, ingrese su nombre",
                phone: {
                    empty: "* Proporcione un teléfono de contacto",
                    invalid: "* El número de teléfono parece incorrecto. Debe tener al menos 5 dígitos"
                },
                address: "* Por favor, proporcione la dirección de entrega",
                comment: "* Por favor, agregue un comentario a su pedido",
                pickupPoint: "* Especifique dónde le gustaría recoger su pedido"
            },
            deliveryInfo: {
                cost: "El costo de entrega a esta zona será"
            },
            agreement: {
                text: "Al continuar, acepta el procesamiento de datos personales y está de acuerdo con el",
                userAgreement: "Acuerdo de Usuario",
                and: "y",
                privacyPolicy: "Política de Privacidad"
            }
        },
        modSelector: {
            outOfStock: "agotado"
        },
        variantSelector: {
            chooseOption: 'Seleccione opción'
        },
        notifications: {
            productStopped: 'Temporalmente no disponible',
            maxQuantityExceeded: 'Hay un límite de {max} artículos por pedido para este producto'
        }
    },
    uz: {
        nav: {
            favorite: 'Sevimlilar',
            search: 'Qidiruv',
            allergens: 'Allergenlar',
        },
        buttons: {
            addToCart: 'Savatchaga qo\'shish'
        },
        search: {
            placeholder: "Qidirish...",
            nothingFound: "Hech narsa topilmadi"
        },
        order: {
            title: "Buyurtma berish",
            success: {
                title: "Tayyor!",
                message: "Buyurtma muvaffaqiyatli joylashtirildi. Tez orada sizga qo'ng'iroq qilamiz",
                orderNumber: "Buyurtma raqamingiz"
            },
            error: {
                title: "Xato",
                placement: "Buyurtmani joylashtrishda xato"
            }
        },
        cart: {
            all: "Hammasi",
            title: "Savatcha",
            empty: "Savatcha bo'sh",
            widget: "Savatchada",
            openMenu: "Menyuni ochish",
            unnamed: "Nomsiz",
            buttons: {
                retry: "Qayta urinish",
                returnToMenu: "Menyuga qaytish",
                saveMenu: "Menyuni telefonga saqlash"
            }
        },
        filters: {
            allergens: 'Allergenlar'
        },
        blocks: {
            recommendations: {
                title: "Tavsiya etiladi",
                empty: "Tavsiyalar yo'q"
            },
            favorites: {
                title: "Sevimli taomlaringiz",
                empty: "Sevimli taomlar yo'q"
            },
            total: {
                sum: "Summa",
                delivery: "Yetkazib berish",
                total: "Jami"
            }
        },
        footer: {
            address: "Manzil",
            contacts: "Kontaktlar",
            privacyPolicy: "Maxfiylik siyosati",
            termsOfUse: "Foydalanish shartlari"
        },
        cartOrder: {
            placeOrder: "Buyurtma berish",
            closed: "Restoran yopiq",
            minOrder: "Minimal buyurtma",
            minOrderMessage: "Buyurtmangiz summasi minimaldan past. Buyurtma berish uchun savatchaga kamida quyidagi summaga teng mahsulotlarni qo'shishingiz kerak",
            deliveryClosedMessage: "Afsuski, yetkazib berish xizmati hozir yopiq. Buyurtmangizni qabul qilamiz va xizmat ochilishi bilan darhol qayta ishlaymiz.",
            openInMinutes: "Yetkazib berish xizmati ochilishiga",
            minutes: "daq.",
            openAt: "Yetkazib berish xizmati ishlaydigan vaqt"
        },
        dmLabel: {
            text: "Bu menyu platformada yaratilgan",
        },
        nutrition: {
            title: "Ozuqaviy qiymat",
            weight: "Porsiya hajmi",
            perServing: "porsiyaga",
            addToFavorites: "Sevimlilarga qo'shish",
            inFavorites: "Sevimlilarda",
            calories: 'kkal',
            proteins: 'oqsillar',
            fats: 'yog\'lar',
            carbs: 'uglevodlar',
            gram: 'g'
        },
        allergens: {
            contains: 'Tarkibida bor',
            avocado: 'Avokado',
            peanuts: 'Yeryong\'oq',
            gluten: 'Gluten',
            mustard: 'Xantal',
            sulphurdioxide: 'Oltingugurt dioksidi',
            sesame: 'Kunjut',
            lupin: 'Lupin',
            molluscs: 'Mollyuskalar',
            milk: 'Sut',
            nuts: 'Yong\'oqlar',
            crustaceans: 'Qisqichbaqasimonlar',
            fish: 'Baliq',
            celery: 'Selderey',
            soya: 'Soya',
            eggs: 'Tuxum'
        },
        addToCart: {
            add: "Qo'shish",
            added: "Qo'shildi"
        },
        details: {
            description: "Tavsif",
            ingredients: "Tarkibi",
            weight: "Og'irligi",
            close: "Yopish"
        },
        price: {
            from: "dan"
        },
        orderScreen: {
            title: "Buyurtma berish",
            deliveryType: {
                label: "Buyurtmani qanday olishni xohlaysiz?",
                onsite: "Joyida",
                delivery: "Yetkazib berish",
                pickup: "Olib ketish"
            },
            fields: {
                deliveryRegion: "Yetkazib berish hududi",
                pickupPoint: "Olib ketish punkti",
                name: "Ism",
                phone: "Telefon",
                address: "Yetkazib berish manzili",
                comment: "Buyurtmaga izoh"
            },
            placeholders: {
                deliveryRegion: "Qaysi tumanga yetkazib berish kerak?",
                name: "Sizni nima deb chaqirishimiz mumkin?",
                phone: "+998 00 000 00 00",
                address: "Qayerga yetkazib berish kerak?",
                comment: "Buyurtmaga izoh"
            },
            errors: {
                deliveryRegion: "* Iltimos, yetkazib berish tumanini tanlang",
                name: "* Iltimos, ismingizni kiriting",
                phone: {
                    empty: "* Aloqa uchun telefon raqamini kiriting",
                    invalid: "* Telefon raqami noto'g'ri ko'rinadi. Kamida 5 ta raqam bo'lishi kerak"
                },
                address: "* Iltimos, yetkazib berish manzilini kiriting",
                comment: "* Iltimos, buyurtmangizga izoh qo'shing",
                pickupPoint: "* Buyurtmani qayerdan olishni xohlashingizni ko'rsating"
            },
            deliveryInfo: {
                cost: "Ushbu tumanga yetkazib berish narxi"
            },
            agreement: {
                text: "Davom etish orqali siz shaxsiy ma'lumotlarni qayta ishlashga rozilik bildirasiz va quyidagilar bilan kelishasiz",
                userAgreement: "Foydalanuvchi kelishuvi",
                and: "va",
                privacyPolicy: "Maxfiylik siyosati"
            }
        },
        modSelector: {
            outOfStock: "mavjud emas"
        },
        variantSelector: {
            chooseOption: 'Variantni tanlang'
        },
        notifications: {
            productStopped: 'Vaqtincha mavjud emas',
            maxQuantityExceeded: 'Ushbu mahsulot uchun buyurtma birligi {max} tadan oshmasligi kerak'
        }
    },
    kk: {
        nav: {
            favorite: 'Таңдаулылар',
            search: 'Іздеу',
            allergens: 'Аллергендер',
        },
        buttons: {
            addToCart: 'Себетке қосу'
        },
        search: {
            placeholder: "Іздеу...",
            nothingFound: "Ештеңе табылмады"
        },
        order: {
            title: "Тапсырыс беру",
            success: {
                title: "Дайын!",
                message: "Тапсырыс сәтті орналастырылды. Жақын арада сізге қоңырау шаламыз",
                orderNumber: "Тапсырыс нөіріңіз"
            },
            error: {
                title: "Қате",
                placement: "Тапсырысты орналастыру қатесі"
            }
        },
        cart: {
            all: "Барлығы",
            title: "Себет",
            empty: "Себет бос",
            widget: "Себетте",
            openMenu: "Мәзірді ашу",
            unnamed: "Атаусыз",
            buttons: {
                retry: "Қайталау",
                returnToMenu: "Мәзірге оралу",
                saveMenu: "Мәзірді телефонға сақтау"
            }
        },
        filters: {
            allergens: 'Аллергендер'
        },
        blocks: {
            recommendations: {
                title: "Ұсынылады",
                empty: "Ұсыныстар жоқ"
            },
            favorites: {
                title: "Сіздің сүйікті тағамдарыңыз",
                empty: "Сүйікті тағамдар жоқ"
            },
            total: {
                sum: "Сома",
                delivery: "Жеткізу",
                total: "Барлығы"
            }
        },
        footer: {
            address: "Мекенжай",
            contacts: "Байланыстар",
            privacyPolicy: "Құпиялылық саясаты",
            termsOfUse: "Қолдану ережелері"
        },
        cartOrder: {
            placeOrder: "Тапсырыс беру",
            closed: "Мейрамхана жабық",
            minOrder: "Минималды тапсырыс",
            minOrderMessage: "Сіздің тапсырысыңыздың сомасы минималды мөлшерден төмен. Тапсырыс беру үшін себетке кем дегенде мынадай сомаға тауар қосу керек",
            deliveryClosedMessage: "Өкінішке орай, жеткізу қызметі қазір жабық. Біз сіздің тапсырысыңызды қабылдаймыз және ол ашылған бойда өңдейміз.",
            openInMinutes: "Жеткізу қызметі ашылуына",
            minutes: "мин.",
            openAt: "Жеткізу қызметі жұмыс істейтін уақыт"
        },
        dmLabel: {
            text: "Бұл мәзір платформада жасалған",
        },
        nutrition: {
            title: "Тағамдық құндылығы",
            weight: "Порция мөлшері",
            perServing: "порцияға",
            addToFavorites: "Таңдаулыларға қосу",
            inFavorites: "Таңдаулыларда",
            calories: 'ккал',
            proteins: 'ақуыздар',
            fats: 'майлар',
            carbs: 'көмірсулар',
            gram: 'г'
        },
        allergens: {
            contains: 'Құрамында бар',
            avocado: 'Авокадо',
            peanuts: 'Жержаңғақ',
            gluten: 'Глютен',
            mustard: 'Қыша',
            sulphurdioxide: 'Күкірт диоксиді',
            sesame: 'Күнжіт',
            lupin: 'Люпин',
            molluscs: 'Моллюскалар',
            milk: 'Сүт',
            nuts: 'Жаңғақтар',
            crustaceans: 'Шаян тәрізділер',
            fish: 'Балық',
            celery: 'Балдыркөк',
            soya: 'Соя',
            eggs: 'Жұмыртқа'
        },
        addToCart: {
            add: "Қосу",
            added: "Қосылды"
        },
        details: {
            description: "Сипаттама",
            ingredients: "Құрамы",
            weight: "Салмағы",
            close: "Жабу"
        },
        price: {
            from: "бастап"
        },
        orderScreen: {
            title: "Тапсырыс беру",
            deliveryType: {
                label: "Тапсырысты қалай алғыңыз келеді?",
                onsite: "Орнында",
                delivery: "Жеткізу",
                pickup: "Алып кету"
            },
            fields: {
                deliveryRegion: "Жеткізу ауданы",
                pickupPoint: "Алып кету пункті",
                name: "Аты",
                phone: "Телефон",
                address: "Жеткізу мекенжайы",
                comment: "Тапсырысқа түсініктеме"
            },
            placeholders: {
                deliveryRegion: "Қай ауданға жетkізу керек?",
                name: "Sizni nima deb chaqirishimiz mumkin?",
                phone: "+7 000 000 00 00",
                address: "Қайда жетkізу керек?",
                comment: "Тапсырысқа түсініkтеме"
            },
            errors: {
                deliveryRegion: "* Жеткізу ауданын таңдаңыз",
                name: "* Атыңызды енгізіңіз",
                phone: {
                    empty: "* Байланыс телефонын көрсетіңіз",
                    invalid: "* Телефон нөмірі дұрыс емес сияқты. Кем дегенде 5 сан болуы керек"
                },
                address: "* Жеткізу мекенжайын көрсетіңіз",
                comment: "* Тапсырысқа түсініkтеме қосыңыз",
                pickupPoint: "* Тапсырысты қайдан алғыңыз келетінін көрсетіңіз"
            },
            deliveryInfo: {
                cost: "Бұл ауданға жетkізу құны"
            },
            agreement: {
                text: "Жалғастыру арқылы сіз жеке деректерді өңдеуге келісім бересіз және келесілермен келісесіз",
                userAgreement: "Қолданушы келісімі",
                and: "және",
                privacyPolicy: "Құпиялылық саясаты"
            }
        },
        modSelector: {
            outOfStock: "қолжетімді емес"
        },
        variantSelector: {
            chooseOption: 'Нұсқаны таңдаңыз'
        },
        notifications: {
            productStopped: 'Уақытша қолжетімсіз',
            maxQuantityExceeded: 'Бұл тауар үшін тапсырыс бірлігі {max} тардан аспауы керек'
        }
    },
    be: {
        nav: {
            favorite: 'Абранае',
            search: 'Пошук',
            allergens: 'Алергены',
        },
        buttons: {
            addToCart: 'Дадаць у кошык'
        },
        search: {
            placeholder: "Пошук...",
            nothingFound: "Нічога не знойдзена"
        },
        order: {
            title: "Афармленне заказу",
            success: {
                title: "Гатова",
                message: "Заказ паспяхова аформлены. Мы патэлефануем вам у бліжэйшы час",
                orderNumber: "Нумар вашага заказу"
            },
            error: {
                title: "Памылка",
                placement: "Памылка размяшчэння заказу"
            }
        },
        cart: {
            all: "Усё",
            title: "Мой кошык",
            empty: "У кошыку няма пазіцый",
            widget: "У кошыку",
            openMenu: "Адкрыць меню",
            unnamed: "Без назвы",
            buttons: {
                retry: "Паўтарыць спробу",
                returnToMenu: "Вярнуцца ў меню",
                saveMenu: "Захаваць меню на тэлефон"
            }
        },
        filters: {
            allergens: 'Алергены'
        },
        blocks: {
            recommendations: {
                title: "Рэкамендуем",
                empty: "Няма рэкамендацый"
            },
            favorites: {
                title: "Вашы любімыя стравы",
                empty: "Няма абраных страў"
            },
            total: {
                sum: "Сума",
                delivery: "Дастаўка",
                total: "Усяго"
            }
        },
        footer: {
            address: "Адрас",
            contacts: "Кантакты",
            privacyPolicy: "Палітыка прыватнасці",
            termsOfUse: "Карыстальніцкае пагадненне"
        },
        cartOrder: {
            placeOrder: "Аформіць заказ",
            closed: "Рэстаран зачынены",
            minOrder: "Мінімальны заказ",
            minOrderMessage: "Сума вашага заказу ніжэй мінімальнай. Для афармлення заказу вам неабходна дадаць у кошык тавары на суму не менш",
            deliveryClosedMessage: "На жаль, зараз служба дастаўкі не працуе, мы прымем ваш заказ і апрацуем яго адразу, як толькі яна адкрыецца.",
            openInMinutes: "Дастаўка адкрыецца праз",
            minutes: "хв.",
            openAt: "Дастаўка працуе з"
        },
        dmLabel: {
            text: "Гэта меню зроблена на платформе",
        },
        nutrition: {
            title: "Харчовая каштоўнасць",
            weight: "Вага порцыі",
            perServing: "на порцыю",
            addToFavorites: "У абранае",
            inFavorites: "У абраным",
            calories: 'ккал',
            proteins: 'бялкі',
            fats: 'тлушчы',
            carbs: 'вугляводы',
            gram: 'г'
        },
        allergens: {
            contains: 'Змяшчае',
            avocado: 'Авакада',
            peanuts: 'Арахіс',
            gluten: 'Глютэн',
            mustard: 'Гарчыца',
            sulphurdioxide: 'Дыяксід серы',
            sesame: 'Кунжут',
            lupin: 'Люпін',
            molluscs: 'Малюскі',
            milk: 'Малако',
            nuts: 'Арэхі',
            crustaceans: 'Ракападобныя',
            fish: 'Рыба',
            celery: 'Сельдэрэй',
            soya: 'Соя',
            eggs: 'Яйкі'
        },
        addToCart: {
            add: "Дадаць",
            added: "Дададзена"
        },
        details: {
            description: "Апісанне",
            ingredients: "Склад",
            weight: "Вага",
            close: "Закрыць"
        },
        price: {
            from: "ад"
        },
        orderScreen: {
            title: "Афармленне заказу",
            deliveryType: {
                label: "Як вы хочаце атрымаць заказ?",
                onsite: "У закладзе",
                delivery: "Даставіць па адрасе",
                pickup: "Самавываз"
            },
            fields: {
                deliveryRegion: "Раён дастаўкі",
                pickupPoint: "Пункт самавывазу",
                name: "Імя",
                phone: "Тэлефон",
                address: "Адрас дастаўкі",
                comment: "Каментар да заказу"
            },
            placeholders: {
                deliveryRegion: "У які раён даставіць?",
                name: "Як да вас звяртацца?",
                phone: "+375 00 000 00 00",
                address: "Куды даставіць?",
                comment: "Каментар да заказу"
            },
            errors: {
                deliveryRegion: "* Калі ласка, выберыце раён",
                name: "* Калі ласка, укажыце імя",
                phone: {
                    empty: "* Укажыце тэлефон для сувязі",
                    invalid: "* Здаецца, тэлефон указаны няправільна. Павінна быць не менш за 5 лічбаў"
                },
                address: "* Калі ласка, укажыце адрас",
                comment: "* Дадайце каментар да заказу",
                pickupPoint: "* Укажыце, дзе б вы хацелі забраць заказ"
            },
            deliveryInfo: {
                cost: "Кошт дастаўкі ў гэты раён складзе"
            },
            agreement: {
                text: "Працягваючы, вы даяце згоду на апрацоўку персанальных дадзеных і пагаджаецеся з",
                userAgreement: "Карыстальніцкім пагадненнем",
                and: "і",
                privacyPolicy: "Палітыкай прыватнасці"
            }
        },
        modSelector: {
            outOfStock: "няма ў наяўнасці"
        },
        variantSelector: {
            chooseOption: 'Выберыце варыянт'
        },
        notifications: {
            productStopped: 'Часова недаступны',
            maxQuantityExceeded: 'Для гэтага тавару ёсць абмежаванне ў {max} адзінак за заказ'
        }
    },
    tr: {
        nav: {
            favorite: 'Favoriler',
            search: 'Arama',
            allergens: 'Alerjenler',
        },
        buttons: {
            addToCart: 'Sepete Ekle'
        },
        search: {
            placeholder: "Ara...",
            nothingFound: "Hiçbir şey bulunamadı"
        },
        order: {
            title: "Sipariş Ver",
            success: {
                title: "Hazır",
                message: "Sipariş başarıyla oluşturuldu. En kısa sürede sizi arayacağız",
                orderNumber: "Sipariş numaranız"
            },
            error: {
                title: "Hata",
                placement: "Sipariş oluşturma hatası"
            }
        },
        cart: {
            all: "Tümü",
            title: "Sepetim",
            empty: "Sepetiniz boş",
            widget: "Sepette",
            openMenu: "Menüyü Aç",
            unnamed: "İsimsiz",
            buttons: {
                retry: "Tekrar Dene",
                returnToMenu: "Menüye Dön",
                saveMenu: "Menüyü Telefona Kaydet"
            }
        },
        filters: {
            allergens: 'Alerjenler'
        },
        blocks: {
            recommendations: {
                title: "Öneriler",
                empty: "Öneri yok"
            },
            favorites: {
                title: "Favori Yemekleriniz",
                empty: "Favori yemek yok"
            },
            total: {
                sum: "Toplam",
                delivery: "Teslimat",
                total: "Genel Toplam"
            }
        },
        footer: {
            address: "Adres",
            contacts: "İletişim",
            privacyPolicy: "Gizlilik Politikası",
            termsOfUse: "Kullanım Koşulları"
        },
        cartOrder: {
            placeOrder: "Sipariş Ver",
            closed: "Restoran kapalı",
            minOrder: "Minimum sipariş",
            minOrderMessage: "Sipariş tutarınız minimum tutarın altında. Sipariş verebilmek için sepetinize en az şu tutarda ürün eklemeniz gerekiyor",
            deliveryClosedMessage: "Üzgünüz, teslimat servisi şu anda kapalı. Siparişinizi alacağız ve servis açıldığında hemen işleme koyacağız.",
            openInMinutes: "Teslimat açılışına",
            minutes: "dk.",
            openAt: "Teslimat çalışma saatleri"
        },
        dmLabel: {
            text: "Bu menü platformunda yapılmıştır",
        },
        nutrition: {
            title: "Besin Değerleri",
            weight: "Porsiyon büyüklüğü",
            perServing: "porsiyon başına",
            addToFavorites: "Favorilere Ekle",
            inFavorites: "Favorilerde",
            calories: 'kcal',
            proteins: 'protein',
            fats: 'yağ',
            carbs: 'karbonhidrat',
            gram: 'g'
        },
        allergens: {
            contains: 'İçerir',
            avocado: 'Avokado',
            peanuts: 'Yer fıstığı',
            gluten: 'Gluten',
            mustard: 'Hardal',
            sulphurdioxide: 'Kükürt dioksit',
            sesame: 'Susam',
            lupin: 'Acı bakla',
            molluscs: 'Yumuşakçalar',
            milk: 'Süt',
            nuts: 'Kuruyemişler',
            crustaceans: 'Kabuklular',
            fish: 'Balık',
            celery: 'Kereviz',
            soya: 'Soya',
            eggs: 'Yumurta'
        },
        addToCart: {
            add: "Ekle",
            added: "Eklendi"
        },
        details: {
            description: "Açıklama",
            ingredients: "İçindekiler",
            weight: "Ağırlık",
            close: "Kapat"
        },
        price: {
            from: "den itibaren"
        },
        orderScreen: {
            title: "Sipariş Ver",
            deliveryType: {
                label: "Siparişinizi nasıl almak istersiniz?",
                onsite: "Restoranda",
                delivery: "Adrese Teslimat",
                pickup: "Gel Al"
            },
            fields: {
                deliveryRegion: "Teslimat bölgesi",
                pickupPoint: "Teslim alma noktası",
                name: "İsim",
                phone: "Telefon",
                address: "Teslimat adresi",
                comment: "Sipariş notu"
            },
            placeholders: {
                deliveryRegion: "Hangi bölgeye teslim edilecek?",
                name: "Size nasıl hitap edelim?",
                phone: "+90 000 000 00 00",
                address: "Sırayla teslim edilecek?",
                comment: "Sipariş notu"
            },
            errors: {
                deliveryRegion: "* Lütfen teslimat bölgesi seçin",
                name: "* Lütfen isminizi girin",
                phone: {
                    empty: "* İletişim için telefon numarası girin",
                    invalid: "* Telefon numarası hatalı görünüyor. En az 5 rakam olmalı"
                },
                address: "* Lütfen teslimat adresini girin",
                comment: "* Lütfen siparişinize not ekleyin",
                pickupPoint: "* Lütfen siparişinizi nereden almak istediğinizi belirtin"
            },
            deliveryInfo: {
                cost: "Teslimat ücreti bu bölgede"
            },
            agreement: {
                text: "Devam ederek, kişisel verilerin işlenmesini kabul ediyorsunuz ve",
                userAgreement: "Kullanıcı Sözleşmesi",
                and: "ve",
                privacyPolicy: "Gizlilik Politikası"
            }
        },
        modSelector: {
            outOfStock: "stokta yok"
        },
        variantSelector: {
            chooseOption: 'Seçenek belirleyin'
        },
        notifications: {
            productStopped: 'Geçici olarak mevcut değil',
            maxQuantityExceeded: 'Bu ürün için sipariş başına {max} adet limiti vardır'
        }
    },
    ka: {
        nav: {
            favorite: 'რჩეულები',
            search: 'ძიება',
            allergens: 'ალერგენები',
        },
        buttons: {
            addToCart: 'კალათაში დამატება'
        },
        search: {
            placeholder: "ძიება...",
            nothingFound: "არაფერი მოიძებნა"
        },
        order: {
            title: "შეკვეთის გაფორმება",
            success: {
                title: "მზადაა",
                message: "შეკვეთა წარმატებით გაფორმდა. უახლოეს დროში დაგიკავშირდებით",
                orderNumber: "თქვენი შეკვეთის ნომერი"
            },
            error: {
                title: "შეცდომა",
                placement: "შეკვეთის განთავსების შეცდომა"
            }
        },
        cart: {
            all: "ყველა",
            title: "ჩემი კალათა",
            empty: "კალათა ცარიელია",
            widget: "კალათაში",
            openMenu: "მენიუს გახსნა",
            unnamed: "უსახელო",
            buttons: {
                retry: "ხელახლა ცდა",
                returnToMenu: "მენიუში დაბრუნება",
                saveMenu: "მენიუს შენახვა ტელეფონში"
            }
        },
        filters: {
            allergens: 'ალერგენები'
        },
        blocks: {
            recommendations: {
                title: "რეკომენდებული",
                empty: "რეკომენდაციები არ არის"
            },
            favorites: {
                title: "თქვენი საყვარელი კერძები",
                empty: "საყვარელი კერძები არ არის"
            },
            total: {
                sum: "ჯამი",
                delivery: "მიტანა",
                total: "სულ"
            }
        },
        footer: {
            address: "მისამართი",
            contacts: "კონტაქტები",
            privacyPolicy: "კონფიდენციალურობის პოლიტიკა",
            termsOfUse: "მოხმარების პირობები"
        },
        cartOrder: {
            placeOrder: "შეკვეთის განთავსება",
            closed: "რესტორანი დახურულია",
            minOrder: "მინიმალური შეკვეთა",
            minOrderMessage: "თქვენი შეკვეთის თანხა მინიმალურზე ნაკლებია. შეკვეთის გასაფორმებლად საჭიროა კალათაში დაამატოთ პროდუქტები მინიმუმ",
            deliveryClosedMessage: "სამწუხაროდ, ამჟამად მიტანის სერვისი არ მუშაობს, ჩვენ მივიღებთ თქვენს შეკვეთას და დავამუშავებთ მას სერვისის გახსნისთანავე.",
            openInMinutes: "მიტანის სერვისი გაიხსნება",
            minutes: "წთ.",
            openAt: "მიტანის სერვისი მუშაობს"
        },
        dmLabel: {
            text: "ეს მენიუ შექმნილია პლატფორმაზე",
        },
        nutrition: {
            title: "კვებითი ღირებულება",
            weight: "პორციის ზომა",
            perServing: "პორციაზე",
            addToFavorites: "ფავორიტებში დამატება",
            inFavorites: "ფავორიტებში",
            calories: 'კკალ',
            proteins: 'ცილები',
            fats: 'ცხიმები',
            carbs: 'ნახშირწყლები',
            gram: 'გ'
        },
        allergens: {
            contains: 'შეიცავს',
            avocado: 'ავოკადო',
            peanuts: 'არაქისი',
            gluten: 'გლუტენი',
            mustard: 'მდოგვი',
            sulphurdioxide: 'გოგირდის დიოქსიდი',
            sesame: 'სეზამი',
            lupin: 'ლუპინი',
            molluscs: 'მოლუსკები',
            milk: 'რძე',
            nuts: 'თხილეული',
            crustaceans: 'კიბოსნაირნი',
            fish: 'თევზი',
            celery: 'ნიახური',
            soya: 'სოია',
            eggs: 'კვერცხი'
        },
        addToCart: {
            add: "დამატება",
            added: "დამატებულია"
        },
        details: {
            description: "აღწერა",
            ingredients: "შემადგენლობა",
            weight: "წონა",
            close: "დახურვა"
        },
        price: {
            from: "დან"
        },
        orderScreen: {
            title: "შეკვეთის გაფორმება",
            deliveryType: {
                label: "როგორ გსურთ შეკვეთის მიღება?",
                onsite: "ადგილზე",
                delivery: "მისამართზე მიტანა",
                pickup: "თვითგატანა"
            },
            fields: {
                deliveryRegion: "მიტანის რაიონი",
                pickupPoint: "გატანის პუნქტი",
                name: "სახელი",
                phone: "ტელეფონი",
                address: "მიტანის მისამართი",
                comment: "კომენტარი შეკვეთაზე"
            },
            placeholders: {
                deliveryRegion: "რომელ რაიონში მივიტანოთ?",
                name: "როგორ მოგმართოთ?",
                phone: "+995 000 000 000",
                address: "სად მივიტანოთ?",
                comment: "კომენტარი შეკვეთაზე"
            },
            errors: {
                deliveryRegion: "* გთხოვთ, აირჩიოთ რაიონი",
                name: "* გთხოვთ, მიუთითოთ სახელი",
                phone: {
                    empty: "* მიუთითეთ საკონტაქტო ტელეფონი",
                    invalid: "* ტელეფონის ნომერი არასწორად არის მითითებული. უნდა იყოს მინიმუმ 5 ციფრი"
                },
                address: "* გთხოვთ, მიუთითოთ მისამართი",
                comment: "* დაამატეთ კომენტარი შეკვეთაზე",
                pickupPoint: "* მიუთითეთ, სად გსურთ შეკვეთის გატანა"
            },
            deliveryInfo: {
                cost: "ამ რაიონში მიტანის ღირებულება შეადგენს"
            },
            agreement: {
                text: "გაგრძელებით თქვენ ეთანხმებით პერსონალური მონაცემების დამუშავებას და",
                userAgreement: "მომხმარებლის შეთანხმებას",
                and: "და",
                privacyPolicy: "კონფიდენციალურობის პოლიტიკას"
            }
        },
        modSelector: {
            outOfStock: "არ არის მარაგში"
        },
        variantSelector: {
            chooseOption: 'აირჩიეთ ვარიანტი'
        },
        notifications: {
            productStopped: 'დროებით მიუწვდომელია',
            maxQuantityExceeded: 'ამ პროდუქტისთვის შეკვეთაზე {max} ცალი ლიმიტია'
        }
    },
    ko: {
        nav: {
            favorite: '즐겨찾기',
            search: '검색',
            allergens: '알레르기 유발 물질',
        },
        buttons: {
            addToCart: '장바구니에 추가'
        },
        search: {
            placeholder: "검색...",
            nothingFound: "검색 결과가 없습니다"
        },
        order: {
            title: "주문하기",
            success: {
                title: "완료",
                message: "주문이 성공적으로 접수되었습니다. 곧 연락드리겠습니다",
                orderNumber: "주문 번호"
            },
            error: {
                title: "오류",
                placement: "주문 접수 오류"
            }
        },
        cart: {
            all: "전체",
            title: "장바구니",
            empty: "장바구니가 비어있습니다",
            widget: "장바구니에",
            openMenu: "메뉴 열기",
            unnamed: "이름 없음",
            notInCart: "아직 장바구니에 추가되지 않았습니다",
            buttons: {
                retry: "다시 시도",
                returnToMenu: "메뉴로 돌아가기",
                saveMenu: "메뉴를 휴대폰에 저장"
            }
        },
        filters: {
            allergens: '알레르기 유발 물질'
        },
        blocks: {
            recommendations: {
                title: "추천 메뉴",
                empty: "추천 메뉴가 없습니다"
            },
            favorites: {
                title: "즐겨찾는 메뉴",
                empty: "즐겨찾는 메뉴가 없습니다"
            },
            total: {
                sum: "금액",
                delivery: "배달비",
                total: "총액"
            }
        },
        footer: {
            address: "주소",
            contacts: "연락처",
            privacyPolicy: "개인정보 처리방침",
            termsOfUse: "이용약관"
        },
        cartOrder: {
            placeOrder: "주문하기",
            closed: "레스토랑이 닫혔습니다",
            minOrder: "최소 주문 금액",
            minOrderMessage: "주문 금액이 최소 주문 금액보다 낮습니다. 주문을 완료하려면 다음 금액 이상의 메뉴를 장바구니에 추가해야 합니다",
            deliveryClosedMessage: "죄송합니다. 현재 배달 서비스가 운영되지 않습니다. 배달 서비스가 시작되는 즉시 주문을 처리하겠습니다.",
            openInMinutes: "배달 서비스 오픈까지",
            minutes: "분.",
            openAt: "배달 서비스 운영 시간:"
        },
        dmLabel: {
            text: "이 메뉴는 다음 플랫폼에서 제작되었습니다",
        },
        nutrition: {
            title: "영양 정보",
            weight: "1인분 중량",
            perServing: "1인분당",
            addToFavorites: "즐겨찾기에 추가",
            inFavorites: "즐겨찾기에 있음",
            calories: '칼로리',
            proteins: '단백질',
            fats: '지방',
            carbs: '탄수화물',
            gram: 'g'
        },
        allergens: {
            contains: '포함',
            cereals: '곡물',
            avocado: '아보카도',
            peanuts: '땅콩',
            gluten: '글루텐',
            mustard: '겨자',
            sulphurdioxide: '이산화황',
            sesame: '참깨',
            lupin: '루핀',
            molluscs: '연체동물',
            milk: '우유',
            nuts: '견과류',
            crustaceans: '갑각류',
            fish: '생선',
            celery: '셀러리',
            soya: '대두',
            eggs: '계란'
        },
        addToCart: {
            add: "추가하기",
            added: "추가됨"
        },
        details: {
            description: "설명",
            ingredients: "재료",
            weight: "중량",
            close: "닫기"
        },
        price: {
            from: "부터"
        },
        orderScreen: {
            title: "주문하기",
            deliveryType: {
                label: "주문을 어떻게 받으시겠습니까?",
                onsite: "매장에서",
                delivery: "배달",
                pickup: "포장"
            },
            fields: {
                deliveryRegion: "배달 지역",
                pickupPoint: "픽업 장소",
                name: "이름",
                phone: "전화번호",
                address: "배달 주소",
                comment: "주문 메모"
            },
            placeholders: {
                deliveryRegion: "어느 지역으로 배달해 드릴까요?",
                name: "이름을 입력해주세요",
                phone: "010-0000-0000",
                address: "어디로 배달해 드릴까요?",
                comment: "주문에 대한 메모"
            },
            errors: {
                deliveryRegion: "* 배달 지역을 선택해주세요",
                name: "* 이름을 입력해주세요",
                phone: {
                    empty: "* 연락 가능한 전화번호를 입력해주세요",
                    invalid: "* 전화번호가 올바르지 않은 것 같습니다. 최소 5자리 이상이어야 합니다"
                },
                address: "* 배달 주소를 입력해주세요",
                comment: "* 주문 메모를 추가해주세요",
                pickupPoint: "* 주문을 픽업할 장소를 선택해주세요"
            },
            deliveryInfo: {
                cost: "이 지역의 배달 비용은 다음과 같습니다"
            },
            agreement: {
                text: "계속 진행함으로써 개인정보 처리에 동의하고",
                userAgreement: "이용약관",
                and: "및",
                privacyPolicy: "개인정보 처리방침"
            }
        },
        modSelector: {
            outOfStock: "품절"
        },
        variantSelector: {
            chooseOption: '옵션을 선택하세요'
        },
        notifications: {
            productStopped: '일시적으로 사용할 수 없음',
            maxQuantityExceeded: '이 상품은 주문당 {max}개로 제한됩니다'
        }
    }
};

export const defaultLocale = 'ru'; 
